import type { TrackModel } from "../../models/models";
import { AUDIO_TYPE, COLLECTION_IDS } from "../../models/dictionary";

export const soundColorTracks: TrackModel[] = [
	{
		id: "ec233638-51de-4440-a0c2-e9d7842df21c",
		slug: "white-noise",
		audioUrlStub: "https://audios.coffitivity.com/white-noise",
		name: "White Noise",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		description:
			"Helps block out distractions, making it great for sleep, focus, or masking background noise  in offices or noisy environments.",
		isLooping: true,
		location: null,
		imageUrlStub: "https://images.coffitivity.com/white-noise",
		albumId: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		collectionId: COLLECTION_IDS.SOUND_COLOR,
		effectIds: ["effects:focus", "effects:relaxation", "effects:sleep"],
		userId: null,
		blend: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:30:00+00",
	},
	{
		id: "8395cad7-00ba-4295-8c08-ef2b5f2908e9",
		slug: "pink-noise",
		name: "Pink Noise",
		audioUrlStub: "https://audios.coffitivity.com/pink-noise",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Often used for sleep improvement and relaxation  since it mimics natural sounds like rain and rustling leaves, creating a soothing atmosphere.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/pink-noise",
		albumId: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		collectionId: COLLECTION_IDS.SOUND_COLOR,
		effectIds: ["effects:sleep", "effects:relaxation", "effects:focus"],
		location: null,
		userId: null,
		blend: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:30:01+00",
	},
	{
		id: "92c9a6bd-4015-428d-826d-b83f0fe1accc",
		slug: "brown-noise",
		name: "Brown Noise",
		audioUrlStub: "https://audios.coffitivity.com/brown-noise",
		type: AUDIO_TYPE.TRACK,
		isPremium: true,
		description:
			"Great for stress relief, deep sleep, and relaxation , as its deep, warm tone resembles rolling thunder or ocean waves, providing a sense of calm.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/brown-noise",
		albumId: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		collectionId: COLLECTION_IDS.SOUND_COLOR,
		effectIds: ["effects:focus", "effects:relaxation", "effects:sleep"],
		location: null,
		userId: null,
		blend: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:30:02+00",
	},
	{
		id: "e008c6c6-b907-412d-bc4c-01502028e1e5",
		slug: "blue-noise",
		name: "Blue Noise",
		audioUrlStub: "https://audios.coffitivity.com/blue-noise",
		type: AUDIO_TYPE.TRACK,
		isPremium: false,
		description:
			"Ideal for tinnitus relief or boosting alertness , as its sharper, airy sound can help mask ringing in the ears or improve concentration.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/blue-noise",
		albumId: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		collectionId: COLLECTION_IDS.SOUND_COLOR,
		effectIds: ["effects:focus", "effects:relaxation", "effects:sleep"],
		location: null,
		userId: null,
		blend: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:30:03+00",
	},
	{
		id: "a9485ae9-10aa-4309-8304-ef45a8aed020",
		slug: "teal-noise",
		name: "Teal Noise",
		type: AUDIO_TYPE.TRACK,
		audioUrlStub: "https://audios.coffitivity.com/teal-noise",
		isPremium: true,
		description:
			"A unique track to Coffitivity, designed to mimic nature. Teal noise is a blend of pink and blue noise to provide a balanced sound that's both calming and energizing.",
		isLooping: true,
		imageUrlStub: "https://images.coffitivity.com/teal-noise",
		albumId: "098fb84c-05ca-4ebd-b33a-5f02081a2264",
		collectionId: COLLECTION_IDS.SOUND_COLOR,
		effectIds: ["effects:relaxation", "effects:focus"],
		location: null,
		userId: null,
		blend: null,
		createdAt: "2025-06-25 20:40:50.977605+00",
		updatedAt: "2025-06-25 20:40:50.977605+00",
		releaseDate: "2025-03-03 11:30:04+00",
	},
];

// const subBass: TrackModel = {
// 	id: "sub_bass_143448",
// 	url: "https://audios.coffitivity.com/sub_bass_143448",
// 	slug: "sub_bass",
// 	name: "Sub Bass",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const deepBass: TrackModel = {
// 	id: "deep_bass_140401",
// 	url: "https://audios.coffitivity.com/deep_bass_140401",
// 	slug: "deep_bass",
// 	name: "Deep Bass",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const bass: TrackModel = {
// 	id: "bass_137538",
// 	url: "https://audios.coffitivity.com/bass_137538",
// 	slug: "bass",
// 	name: "Bass",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const lowMids: TrackModel = {
// 	id: "low_mids_141861",
// 	url: "https://audios.coffitivity.com/low_mids_141861",
// 	slug: "low_mids",
// 	name: "Low Mids",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const midrange: TrackModel = {
// 	id: "midrange_142281",
// 	url: "https://audios.coffitivity.com/midrange_142281",
// 	slug: "midrange",
// 	name: "Midrange",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const upperMids: TrackModel = {
// 	id: "upper_mids_143816",
// 	url: "https://audios.coffitivity.com/upper_mids_143816",
// 	slug: "upper_mids",
// 	name: "Upper Mids",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const presence: TrackModel = {
// 	id: "presence_142693",
// 	url: "https://audios.coffitivity.com/presence_142693",
// 	slug: "presence",
// 	name: "Presence",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const highPresence: TrackModel = {
// 	id: "high_presence_141405",
// 	url: "https://audios.coffitivity.com/high_presence_141405",
// 	slug: "high_presence",
// 	name: "High Presence",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const brilliance: TrackModel = {
// 	id: "brilliance_139613",
// 	url: "https://audios.coffitivity.com/brilliance_139613",
// 	slug: "brilliance",
// 	name: "Brilliance",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// const sparkle: TrackModel = {
// 	id: "sparkle_143073",
// 	url: "https://audios.coffitivity.com/sparkle_143073",
// 	slug: "sparkle",
// 	name: "Sparkle",
// 	type: "track",
// 	isPremium: false,
// 	isSearchable: false,
// 	isLooping: true,
// 	album: null,
// 	internalNote: null,
// 	location: null,
// 	collection: "soundColor",
// 	positiveEffectDescription: [],
// 	effectLabels: [],
// 	imageUrl: "",
// 	releaseDate: "2025-04-08T11:30:00",
// 	description: "",
// };

// [
// 	{
// 		id: "white_noise",
// 		slug: "white_noise",
// 		name: "White Noise",
// 		type: "blend",
// 		releaseDate: "2025-03-03T11:30:00",
// 		isPremium: false,
// 		isSearchable: true,
// 		description:
// 			"Helps block out distractions, making it great for sleep, focus, or masking background noise  in offices or noisy environments.",
// 		isLooping: true,
// 		collection: "soundColor",
// 		imageUrl: whiteNoise,
// 		album: null,
// 		internalNote: null,
// 		positiveEffectDescription: [
// 			"Increasing concentration",
// 			"Improving sleep and relaxation",
// 			"Managing tinnitus",
// 		],
// 		effectLabels: ["focus", "relaxation", "sleep"],
// 		blend: [
// 			{
// 				volume: 0.02,
// 				track: subBass,
// 			},
// 			{
// 				volume: 0.04,
// 				track: deepBass,
// 			},
// 			{
// 				volume: 0.06,
// 				track: bass,
// 			},
// 			{
// 				volume: 0.08,
// 				track: lowMids,
// 			},
// 			{
// 				volume: 0.11,
// 				track: midrange,
// 			},
// 			{
// 				volume: 0.14,
// 				track: upperMids,
// 			},
// 			{
// 				volume: 0.18,
// 				track: presence,
// 			},
// 			{
// 				volume: 0.22,
// 				track: highPresence,
// 			},
// 			{
// 				volume: 0.26,
// 				track: brilliance,
// 			},
// 			{
// 				volume: 0.26,
// 				track: sparkle,
// 			},
// 		],
// 	},
// 	{
// 		id: "pink_noise",
// 		slug: "pink_noise",
// 		name: "Pink Noise",
// 		type: "blend",
// 		releaseDate: "2025-03-03T11:30:01",
// 		isPremium: true,
// 		isSearchable: true,
// 		description:
// 			"Often used for sleep improvement and relaxation  since it mimics natural sounds like rain and rustling leaves, creating a soothing atmosphere.",
// 		isLooping: true,
// 		collection: "soundColor",
// 		imageUrl: pinkNoise,
// 		album: null,
// 		internalNote: null,
// 		positiveEffectDescription: [
// 			"Falling asleep faster",
// 			"Staying asleep longer",
// 			"Improving memory",
// 		],
// 		effectLabels: ["sleep", "relaxation", "focus"],
// 		blend: [
// 			{
// 				volume: 0.28,
// 				track: subBass,
// 			},
// 			{
// 				volume: 0.28,
// 				track: deepBass,
// 			},
// 			{
// 				volume: 0.28,
// 				track: bass,
// 			},
// 			{
// 				volume: 0.28,
// 				track: lowMids,
// 			},
// 			{
// 				volume: 0.28,
// 				track: midrange,
// 			},
// 			{
// 				volume: 0.28,
// 				track: upperMids,
// 			},
// 			{
// 				volume: 0.28,
// 				track: presence,
// 			},
// 			{
// 				volume: 0.28,
// 				track: highPresence,
// 			},
// 			{
// 				volume: 0.28,
// 				track: brilliance,
// 			},
// 			{
// 				volume: 0.28,
// 				track: sparkle,
// 			},
// 		],
// 	},
// 	{
// 		id: "brown_noise",
// 		slug: "brown_noise",
// 		name: "Brown Noise",
// 		type: "blend",
// 		releaseDate: "2025-03-03T11:30:02",
// 		isPremium: true,
// 		isSearchable: true,
// 		description:
// 			"Great for stress relief, deep sleep, and relaxation , as its deep, warm tone resembles rolling thunder or ocean waves, providing a sense of calm.",
// 		isLooping: true,
// 		collection: "soundColor",
// 		imageUrl: brownNoise,
// 		album: null,
// 		internalNote: null,
// 		positiveEffectDescription: [
// 			"Improving focus",
// 			"Enhancing relaxation",
// 			"Reducing stress",
// 			"Sleep aid",
// 		],
// 		effectLabels: ["focus", "relaxation", "sleep"],
// 		blend: [
// 			{
// 				volume: 0.28,
// 				track: subBass,
// 			},
// 			{
// 				volume: 0.26,
// 				track: deepBass,
// 			},
// 			{
// 				volume: 0.22,
// 				track: bass,
// 			},
// 			{
// 				volume: 0.18,
// 				track: lowMids,
// 			},
// 			{
// 				volume: 0.14,
// 				track: midrange,
// 			},
// 			{
// 				volume: 0.11,
// 				track: upperMids,
// 			},
// 			{
// 				volume: 0.08,
// 				track: presence,
// 			},
// 			{
// 				volume: 0.06,
// 				track: highPresence,
// 			},
// 			{
// 				volume: 0.04,
// 				track: brilliance,
// 			},
// 			{
// 				volume: 0.02,
// 				track: sparkle,
// 			},
// 		],
// 	},
// 	{
// 		id: "blue_noise",
// 		slug: "blue_noise",
// 		name: "Blue Noise",
// 		type: "blend",
// 		releaseDate: "2025-03-03T11:30:03",
// 		isPremium: false,
// 		isSearchable: true,
// 		description:
// 			"Ideal for tinnitus relief or boosting alertness , as its sharper, airy sound can help mask ringing in the ears or improve concentration.",
// 		isLooping: true,
// 		collection: "soundColor",
// 		imageUrl: blueNoise,
// 		album: null,
// 		internalNote: null,
// 		positiveEffectDescription: [
// 			"Boosting Alertness",
// 			"Improving focus",
// 			"Managing tinnitus",
// 		],
// 		effectLabels: ["focus", "relaxation", "sleep"],
// 		blend: [
// 			{
// 				volume: 0.02,
// 				track: midrange,
// 			},
// 			{
// 				volume: 0.04,
// 				track: upperMids,
// 			},
// 			{
// 				volume: 0.08,
// 				track: presence,
// 			},
// 			{
// 				volume: 0.16,
// 				track: highPresence,
// 			},
// 			{
// 				volume: 0.32,
// 				track: brilliance,
// 			},
// 			{
// 				volume: 0.64,
// 				track: sparkle,
// 			},
// 		],
// 	},
// 	{
// 		id: "teal_noise",
// 		slug: "teal_noise",
// 		name: "Teal Noise",
// 		type: "blend",
// 		releaseDate: "2025-03-03T11:30:04",
// 		isPremium: true,
// 		isSearchable: true,
// 		description:
// 			"A unique track to Coffitivity, designed to mimic nature. Teal noise is a blend of pink and blue noise to provide a balanced sound that's both calming and energizing.",
// 		isLooping: true,
// 		collection: "soundColor",
// 		imageUrl: tealNoise,
// 		album: null,
// 		internalNote: null,
// 		positiveEffectDescription: [
// 			"Immersive ASMR sensation",
// 			"Reducing stress and tension",
// 			"Enhancing relaxation",
// 		],
// 		effectLabels: ["relaxation", "focus"],
// 		blend: [
// 			{
// 				volume: 0.025,
// 				track: subBass,
// 			},
// 			{
// 				volume: 0.05,
// 				track: deepBass,
// 			},
// 			{
// 				volume: 0.1,
// 				track: bass,
// 			},
// 			{
// 				volume: 0.25,
// 				track: lowMids,
// 			},
// 			{
// 				volume: 0.3,
// 				track: midrange,
// 			},
// 			{
// 				volume: 0.3,
// 				track: upperMids,
// 			},
// 			{
// 				volume: 0.25,
// 				track: presence,
// 			},
// 			{
// 				volume: 0.2,
// 				track: highPresence,
// 			},
// 			{
// 				volume: 0.15,
// 				track: brilliance,
// 			},
// 			{
// 				volume: 0.1,
// 				track: sparkle,
// 			},
// 		],
// 	},
// ];
